import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { cx } from '../../pages/Home/HomeDashboard/dashboardStyles';
import { COLORS2, REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

const useStyles = makeStyles(() => ({
    button: {
        display: 'grid',
        placeItems: 'center',
        width: '34px',
        height: '34px',
        padding: 0,
        border: `1px solid ${REDESIGN_COLORS.line}`,
        borderRadius: '50%',
        color: REDESIGN_COLORS.dark,
        background: REDESIGN_COLORS.white,
        cursor: 'pointer',
        '&:hover': {
            borderColor: REDESIGN_COLORS.primary,
            color: REDESIGN_COLORS.link,
        },
    },
    paper: {
        minWidth: '220px',
        marginTop: '6px',
        border: `1px solid ${REDESIGN_COLORS.sand}`,
        borderRadius: '16px',
        boxShadow: '0 12px 32px rgba(6, 63, 69, 0.12)',
    },
    item: {
        gap: '10px',
        padding: '10px 16px',
        fontFamily: REDESIGN_FONTS.body,
        fontSize: '0.92rem',
        fontWeight: REDESIGN_FONTS.weightStrong,
        color: REDESIGN_COLORS.dark,
    },
    danger: {
        color: COLORS2.virtualRed,
    },
    icon: {
        width: '18px',
        height: '18px',
    },
    badge: {
        marginLeft: 'auto',
        minWidth: '22px',
        padding: '2px 7px',
        borderRadius: '999px',
        background: REDESIGN_COLORS.amberBadge,
        color: REDESIGN_COLORS.dark,
        fontSize: '0.74rem',
        fontWeight: REDESIGN_FONTS.weightHeading,
        textAlign: 'center',
    },
}));

/**
 * The "⋯" menu of secondary actions on a group. `actions` is a list of
 * `{ key, labelId, onClick, icon, badge, danger }`; `row` is passed to each
 * onClick. Renders nothing when there are no actions.
 */
const GroupActionsMenu = ({ row, actions = [] }) => {
    const classes = useStyles();
    const intl = useIntl();
    const [anchor, setAnchor] = useState(null);

    if (!actions.length) return null;

    const pick = (action) => {
        setAnchor(null);
        action.onClick(row);
    };

    return (
        <>
            <button
                type="button"
                aria-label={intl.formatMessage({ id: 'redesign.groups.actions' })}
                aria-haspopup="true"
                aria-expanded={!!anchor}
                onClick={(event) => setAnchor(event.currentTarget)}
                className={classes.button}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <circle cx="5" cy="12" r="2" />
                    <circle cx="12" cy="12" r="2" />
                    <circle cx="19" cy="12" r="2" />
                </svg>
            </button>
            <Menu
                anchorEl={anchor}
                open={!!anchor}
                onClose={() => setAnchor(null)}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                disableScrollLock
                classes={{ paper: classes.paper }}
            >
                {actions.map((action) => (
                    <MenuItem
                        key={action.key}
                        onClick={() => pick(action)}
                        className={cx(classes.item, action.danger && classes.danger)}
                    >
                        {action.icon ? <action.icon className={classes.icon} /> : null}
                        <FormattedMessage id={action.labelId} />
                        {action.badge ? <span className={classes.badge}>{action.badge}</span> : null}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default GroupActionsMenu;
